import React, { useState, useRef, useEffect } from 'react';
import { X, Plus, Minus, ShoppingCart } from 'lucide-react'; 
import { apiUrl, assetsUrl } from '../config/Config';
import axios from 'axios';
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom';
import noimage from '../assets/images/no-image.jpeg';


import product3 from '../assets/images/product3.webp'; 

const CartPage = ({ onClose }) => {
    const dispatch = useDispatch();
    const cartdata = useSelector((store) => store.userReducer.cartdata);
    const customerdata = useSelector((store) => store.userReducer.customerdata);
    const navigate = useNavigate();
    const location = useLocation();
    const [samplecartdata, setsamplecartdata] = useState([]);
    const [forceupdate, setforceupdate] = useState(false);
    const samplecartdataRef = useRef(null);
    samplecartdataRef.current = samplecartdata;


    
    const cartItem = {
        id: 101,
        name: "Hooded Zips Plain Long Sleeve Hoodies - Red/S",
        price: 125.00,
        quantity: 1,
        image: product3, 
        note: "1 X 1.5k" 
    };

    const cartTotal = cartItem.price * cartItem.quantity;

    const removecartitem = (index) => {
      var prevdata = samplecartdataRef.current;
      var newarr = prevdata.filter((item, i) => i !== index);
      setsamplecartdata(newarr);
      dispatch({ type: "cartdata", payload: newarr });
    }

    const handleqtyincrement = (index) => {
      // Deep copy the array
      const newData = [...samplecartdataRef.current];
    
      // If your items inside have nested objects, clone them too
      newData[index] = { ...newData[index] };
    
      const currentqty = newData[index].quantity;
      const stock = newData[index].stock;
    
      if (currentqty < stock) {
        newData[index].quantity = currentqty + 1;
      }
    
      console.log("changes >>", newData);
    
      setsamplecartdata(newData);
      dispatch({ type: "cartdata", payload: newData });
    };

    const handleqtydecrement = (index) => {
         // Deep copy the array
      const newData = [...samplecartdataRef.current];
    
      // If your items inside have nested objects, clone them too
      newData[index] = { ...newData[index] };
    
      const currentqty = newData[index].quantity;
      const stock = newData[index].stock;

      if (currentqty > 1) {
        newData[index].quantity = currentqty - 1;
      }
    
      console.log("changes >>", newData);
    
      setsamplecartdata(newData);
      dispatch({ type: "cartdata", payload: newData });
    }

    const getCartTotal = () => {
      const newData = [...samplecartdataRef.current];
      return newData.reduce((total, item) => {
        return total + (item.quantity * item.price);
      }, 0);
    };

    const isItemOutOfStock = (item) => Number(item?.stock || 0) <= 0;

    const isItemUnavailable = (item) => {
      return isItemOutOfStock(item) || Number(item?.quantity || 0) > Number(item?.stock || 0);
    };

    const hasUnavailableItems = () => {
      return samplecartdataRef.current?.some((item) => isItemUnavailable(item));
    };

    const handleCheckout = () => {
      if (hasUnavailableItems()) {
        return;
      }

      const isLoggedIn = customerdata && Object.keys(customerdata).length > 0;

      if (isLoggedIn) {
        navigate('/Checkout');
        return;
      }

      navigate('/login', {
        state: {
          from: location.pathname,
          redirectTo: '/Checkout',
        },
      });
    };

    useEffect(() => {
        setsamplecartdata(cartdata);
    }, [cartdata])

    return (
      <div>
        <div className="cart-page-overlay">
          <div className="cart-page-container">
            <div className="cart-page-header">
              <div className="cart-page-item-count">
                <ShoppingCart size={18} className="cart-page-icon" />
                <span>
                  {cartdata && Object.keys(cartdata)?.length > 0
                    ? cartdata?.length
                    : 0}{" "}
                  Item
                </span>
              </div>

              {onClose && (
                <button className="cart-page-close-button" onClick={onClose}>
                  <X size={14} className="cartpage-close-icon" />
                </button>
              )}
            </div>
            {/* Cart Body: List of Items */}
            {samplecartdataRef.current?.length > 0 ? 
            <div className="cart-page-body">
              {samplecartdataRef.current?.map((item, index) => {
                console.log('caret item >>', item  )
                const outOfStock = isItemOutOfStock(item);
                const unavailable = isItemUnavailable(item);
                return (
                  <div key={index}>
                    {/* Cart Item Card */}
                  <div className={`cart-page-item-card ${unavailable ? "cart-page-item-card-unavailable" : ""}`} >
                    {/* Quantity Controls */}
                    <div className="cart-page-quantity-controls">
                      <button className="cart-page-qty-button cart-page-minus" disabled={outOfStock} onClick={() => {
                        handleqtydecrement(index)
                      }}>
                        <Minus size={14} />
                      </button>
                      <span className="cart-page-qty-display">
                        {item.quantity}
                      </span>
                      <button className="cart-page-qty-button cart-page-plus" disabled={outOfStock || Number(item?.quantity || 0) >= Number(item?.stock || 0)} onClick={() => {handleqtyincrement(index)}}>
                        <Plus size={14} />
                      </button>
                    </div>
  
                    {/* Item Image */}
                    <div className="cart-page-item-image-wrapper">
                      <img
                        src={assetsUrl + "products/" + item.cartimage}
                        alt={item.name}
                        className="cart-page-item-image"
                        onError={(e) => {
                          e.target.src = noimage // fallback image
                        }}
                      />
                    </div>
  
                    {/* Item Details */}
                    <div className="cart-page-item-details">
                      <h4 className="cart-page-item-name">{item?.name}</h4>
                      {outOfStock ? (
                        <span className="cart-page-stock-status cart-page-stock-status-out">
                          Out of Stock
                        </span>
                      ) : Number(item?.quantity || 0) >= Number(item?.stock || 0) ? (
                        <span className="cart-page-stock-status">
                          Only {Number(item?.stock || 0)} available
                        </span>
                      ) : null}
                      <span className="cart-page-item-price">
                      ₹ {parseInt(item.price).toFixed(2)}
                      </span>
                      <span className="cart-page-item-note">{parseInt(item?.quantity) + " X " + parseInt(item.price).toFixed(2)}</span>
                    </div>
  
                    {/* Item Total Price and Remove Button */}
                    <div className="cart-page-item-actions">
                      <span className="cart-page-item-total-price">
                      ₹ {parseInt(item?.quantity) * parseInt(item.price).toFixed(2)}
                      </span>
                      <button className="cart-page-item-remove-button" onClick={() => {removecartitem(index)}}>
                        <X size={14} />
                      </button>
                    </div>
                  </div>
                  
                  </div>
                  
                )
              })
            }
             </div>
             : (
              <div className="cart-page-body">
                <p className="emptycart-text">Empty Cart</p>
              </div>
            )}

            {/* Cart Footer: Checkout Button */}
            {samplecartdataRef.current?.length > 0 ? (
              <div className="cart-page-footer">
                {hasUnavailableItems() && (
                  <p className="cart-page-unavailable-message">
                    Update or remove unavailable items to continue checkout.
                  </p>
                )}
                <button className="cart-page-checkout-button" onClick={handleCheckout} disabled={hasUnavailableItems()}>
                  <span className="cart-page-checkout-text">
                    {hasUnavailableItems() ? "Checkout unavailable" : "Checkout"}
                  </span>
                  <span className="cart-page-checkout-amount">
                  ₹ {getCartTotal().toFixed(2)}
                  </span>
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
}

export default CartPage;

















